const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Norwegian letters are disallowed everywhere in the address - both before
// and after @ - per product requirement, even though they're otherwise
// valid in email addresses.
const DISALLOWED_CHARS_REGEX = /[æøåÆØÅ]/;

export function validateEmail(value: string | undefined, errorMessage: string): string | true {
  const trimmed = value?.trim();

  if (!trimmed) return true; // required is handled separately by the form

  if (!EMAIL_REGEX.test(trimmed) || DISALLOWED_CHARS_REGEX.test(trimmed)) {
    return errorMessage;
  }

  return true;
}

export default validateEmail;
